var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"button-floating",class:_vm.classes,attrs:{"disabled":_vm.disabled || _vm.loading}},_vm.$listeners),[(!_vm.loading)?_c('i',{staticClass:"button-floating__icon",class:_vm.icon}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }